import { render, staticRenderFns } from "./GroupResults.vue?vue&type=template&id=798557d2&scoped=true&"
import script from "./GroupResults.vue?vue&type=script&lang=ts&"
export * from "./GroupResults.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798557d2",
  null
  
)

export default component.exports